import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  isLoggedIn,
  check_allowed_role,
  isServiceProvider,
  PLANT_USER,
} from "../../utils/AuthService";
import Header from "../../components/layouts/Header";
import Footer from "../../components/layouts/Footer";
import Sidebar from "./Sidebar";
import { chekAllPermissions } from "../../utils/permissons";
import { canUseRefinedAppUI, canUseRefinedProductionUI } from "../../utils/featureFlags";
import RefinedUIProvider from "../../components/generics/RefinedUIProvider";
import useRoutePrefetch from "../../hooks/useRoutePrefetch";
import useRefinedRouteScrollReset from "../../hooks/useRefinedRouteScrollReset";
import { getRefinedUIRouteContext } from "../../utils/refinedUIRoutes";

const DefaultLayout = ({
  permissionsRequired,
  rolesRequired = [PLANT_USER],
  isFeatureFlag,
}) => {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const { pathname } = useLocation();
  const prefetchRootRef = useRoutePrefetch(pathname);
  const refinedUI = canUseRefinedAppUI(currentUser);
  useRefinedRouteScrollReset(pathname, refinedUI);

  if (!isLoggedIn()) {
    return <Navigate to="/login" />;
  }

  // Service providers should only access the provider portal
  if (isServiceProvider()) {
    return <Navigate to="/provider-portal" />;
  }

  const allowedByPermissions = permissionsRequired
    ? chekAllPermissions(permissionsRequired)
    : false;
  const allowedRole = check_allowed_role(rolesRequired);

  if (isFeatureFlag && !allowedByPermissions) {
    return <Navigate to="/orders" />;
  }

  if (!allowedByPermissions && !allowedRole) {
    return <Navigate to="/orders" />;
  }

  const routeContext = getRefinedUIRouteContext(pathname, {
    refinedProductionUI: canUseRefinedProductionUI(currentUser),
  });
  const refinedContentClass = refinedUI
    ? ` refined-ui-content ${routeContext.className}`
    : "";

  return (
    <RefinedUIProvider enabled={refinedUI}>
      <div ref={prefetchRootRef} className={`app${refinedUI ? " app--refined" : ""}`}>
        <Header refinedUI={refinedUI} />
        <div className="app-body">
          <Sidebar refinedUI={refinedUI} />
          <main className="main">
            <div className={`container-fluid mt-2${refinedContentClass}`}>
              <Outlet />
            </div>
          </main>
        </div>
        <Footer />
      </div>
    </RefinedUIProvider>
  );
};

export default DefaultLayout;
